import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  mainPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (min-width: 640px)': {
      margin: '16px 24px',
      padding: '24px',
    },
  },
  detailsMapGrid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    height: 'fit-content',
    flexWrap: 'wrap',
    '@media (min-width: 640px)': {
      gap: '24px',
      paddingBottom: '24px',
    },
  },
  detailsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '@media (max-width: 640px)': {
      width: 'auto',
      margin: '24px 16px',
    },
  },
  topImage: {
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'unset',
      maxWidth: '100%',
      maxHeight: '400px',
    },
  },
  detailsHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  detailsContent: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '16px',
  },
  detailsContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '18px',
  },
  detailsHeaderTitleText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '30px',
  },
  detailsHeaderContentText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  detailsContentTitleText: {
    color: theme.evPalette.charcoal[600],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    minWidth: '30%',
    '@media (min-width: 640px)': {
      width: '120px',
      minWidth: '0%',
    },
  },
  message: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  clickable: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    textDecoration: 'none',
    color: theme.evPalette.ocean[500],
  },
  editPitchContainer: {
    backgroundColor: theme.evPalette.charcoal[100],
    minHeight: '300px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '@media (min-width: 640px)': {
      minHeight: '600px',
    },
  },
  saveReportBtn: {
    padding: '10px 16px',
  },
  linksAndBtn: {
    display: 'flex',
    flexDirection: 'column',
    padding: 24,
    '@media (min-width:640px)': {
      padding: 0,
      alignItems: 'flex-start',
    },
  },
  editPitchComponent: {
    height: '100%',
    width: '60%',
    borderRadius: '6px',
    '@media (max-width: 640px)': { width: '100%', borderRadius: '0px' },
  },
  saveReportLoaderBtn: {
    width: '124px',
    height: '44px',
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },
}));
